import React, { useState, useEffect, useRef, memo } from "react";
import { Col } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import {
	formatBigNum,
	chartBgc,
	chartWatermark,
	chartDataSorter,
} from "../utils";
import moment from "moment";

const EmailTrendChart = ({
	dataFetched,
	isLoading,
	chartData,
	startDate,
	endDate,
	graphRef,
	displayedDates,
	setDisplayedDates,
	totalData,
	setTotalData,
	readData,
	setReadData,
	deletedData,
	setDeletedData,
	title,
}) => {
	useEffect(() => {
		const loadDisplayData = () => {
			let tempTotalData = [];
			let tempReadData = [];
			let tempDeletedData = [];
			let tempDateData = [];

			chartData.sort(chartDataSorter);

			for (let i = 0; i < chartData.length; i++) {
				if (
					new Date(chartData[i].start_date) >= new Date(startDate) &&
					new Date(chartData[i].end_date) <= new Date(endDate)
				) {
					tempTotalData.push(chartData[i].adjusted_total_volume);
					tempReadData.push(chartData[i].adjusted_read_volume);
					tempDeletedData.push(chartData[i].adjusted_delete_volume);
					tempDateData.push(chartData[i].end_date);
				}
			}

			let buffer_start = moment(tempDateData[0]).subtract(14, "d");
			let buffer_end = moment(tempDateData[tempDateData.length - 1]).add(
				14,
				"d"
			);
			tempDateData.unshift(buffer_start.format("YYYY-MM-DD"));
			tempDateData.push(buffer_end.format("YYYY-MM-DD"));
			tempTotalData.push(null);
			tempReadData.push(null);
			tempDeletedData.push(null);
			tempTotalData.unshift(null);
			tempReadData.unshift(null);
			tempDeletedData.unshift(null);

			setTotalData(tempTotalData);
			setReadData(tempReadData);
			setDeletedData(tempDeletedData);
			setDisplayedDates(tempDateData);
		};
		loadDisplayData();
	}, [dataFetched, isLoading, startDate, endDate, chartData]);

	if (!dataFetched) {
		return <div></div>;
	} else if (isLoading) {
		return <h3>Chart Loading...</h3>;
	}

	return (
		<Col sm={12}>
			<React.Fragment>
				<Line
					ref={graphRef}
					height={300}
					className="history-container"
					data={{
						labels: displayedDates,
						datasets: [
							{
								data: totalData,
								type: "line",
								label: "Total",
								borderColor: "#0000FF",
								pointRadius: 0,
							},
							{
								data: readData,
								type: "bar",
								label: "Read",
								backgroundColor: "#00A36C",
							},
							{
								data: deletedData,
								type: "bar",
								label: "Deleted",
								backgroundColor: "#C70039",
							},
						],
					}}
					options={{
						responsive: true,
						maintainAspectRatio: false,
						scales: {
							xAxes: [
								{
									gridLines: {
										display: false,
									},
									type: "time",
									time: {
										unit: "month",
									},
									stacked: true,
								},
							],
							yAxes: [
								{
									id: "A",
									type: "linear",
									position: "left",
									ticks: {
										callback: (value) => formatBigNum(value),
									},
									gridLines: {
										borderDash: [8, 4],
									},
									stacked: true,
								},
							],
						},
						title: {
							text: title,
							fontSize: 15,
							display: true,
						},
					}}
					plugins={[chartBgc, chartWatermark]}
				/>
			</React.Fragment>
		</Col>
	);
};

export default memo(EmailTrendChart);
